<template>
  <div class="page-container">
    <Filter ref="filterRef" :params="params" @search="searchData"></Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage">
      <el-table-column prop="robotId" :label="$t('activity.packetjoin.robotCode')" />
      <!-- <el-table-column prop="productName" label="产品名称" />
      <el-table-column prop="robotModel" label="规格型号" /> -->
      <!-- <el-table-column prop="cabinetId" :label="$t('equipment.cabinet.ctrlCode')" /> -->
      <el-table-column prop="cabinetId" :label="$t('equipment.cabinet.ctrlCode')">
        <template #default="scope">
          <span v-if="scope.row.cabinetId?.length > 4 && ![undifined, 'undifined', 'Invalid-ID'].includes(scope.row.cabinetId)">{{scope.row.cabinetId}}</span>
          <el-popover
            v-else
            placement="top-start"
            :width="400"
            trigger="hover"
            title=""
          >
            <template #default>
              <el-descriptions title="" column="1" border>
                <el-descriptions-item :label="$t('error.alarm.reportinformation')">{{scope.row.cabinetId}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.solution')">{{$t('error.alarm.solutionInfo')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method1')">{{$t('error.alarm.methodInfo1')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method2')">{{$t('error.alarm.methodInfo2')}}</el-descriptions-item>
              </el-descriptions>
            </template>
            <template #reference>
              <span style="cursor: pointer;">
                {{ $t('error.alarm.pendingReport') }}
                <i class="el-icon-warning" style="margin-left: 6px;color: #E6A23C;"></i>
              </span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="errorCode" :label="$t('error.alarm.alarmCode')" >
        <template #default="scope">
          <a @click="errorInfoFun(scope.row)" :style="`color: ${scope.row.errorType == '0' ? '#FF9800' : '#E91E63' }; cursor: pointer`">{{scope.row.errorCode}}</a>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="errorCode" :label="$t('error.alarm.alarmCode')" /> -->
      <el-table-column prop="errorDescription" :label="$t('error.alarm.alarmDetails')" />
      <el-table-column prop="time" :label="$t('error.alarm.occurrenceTime')" />
      <el-table-column prop="queryTime" :label="$t('error.alarm.queryTime')" />
      <!-- <el-table-column label="操作" width="100">
        <template #default="scope">
          <el-button type="primary" plain size="mini" @click="handleClick(scope.row)"
            >刷新状态</el-button
          >
        </template>
      </el-table-column> -->
    </Table>
  </div>
  <!-- <Dialog :errorInfo="errorInfo" :dialogErrorCode="dialogErrorCode"></Dialog> -->
  <el-dialog v-model="dialogErrorCode" :modal="true" :append-to-body="true" width="750px" top="25vh">
    <!-- 自定义header -->
      <template #title>
        <div class="custom-dialog-header">
          <div style="display: flex; align-items: center;">
            <i v-if="errorInfo.errorType == '0'" class="el-icon-warning custom-icon" style="color: #FF9800; font-size: 24px; margin-right: 12px;"></i>
            <i v-if="errorInfo.errorType == '1'" class="el-icon-circle-close custom-icon" style="color: #E91E63; font-size: 24px; margin-right: 12px;"></i>
            <span class="custom-title">{{`${errorInfo.errorType == '0' ? $t('error.alarm.warning') : $t('error.alarm.error')} ${errorInfo.errorCode}`}}</span>
          </div>
          <!-- <button class="custom-close-btn" @click="dialogErrorCode = false">
            <i class="el-icon-close"></i>
          </button> -->
        </div>
      </template>
    <div class="errBoxMain">
      <div class="errorRow">
        <div class="errorLabel">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="errorIcon" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="#525A80"></circle><path fill-rule="evenodd" clip-rule="evenodd" d="M6 8C6 7.44772 6.44772 7 7 7H17C17.5523 7 18 7.44772 18 8V17C18 17.3949 17.7676 17.7528 17.4068 17.9135C17.0461 18.0742 16.6246 18.0075 16.331 17.7433L14.6163 16.2H7C6.44772 16.2 6 15.7523 6 15.2V8ZM9.80156 12.7008C10.4643 12.7008 11.0016 12.1635 11.0016 11.5008C11.0016 10.838 10.4643 10.3008 9.80156 10.3008C9.13882 10.3008 8.60156 10.838 8.60156 11.5008C8.60156 12.1635 9.13882 12.7008 9.80156 12.7008ZM14.3008 12.7008C14.9635 12.7008 15.5008 12.1635 15.5008 11.5008C15.5008 10.838 14.9635 10.3008 14.3008 10.3008C13.638 10.3008 13.1008 10.838 13.1008 11.5008C13.1008 12.1635 13.638 12.7008 14.3008 12.7008Z" fill="white"></path></svg>
          {{ $t('error.alarm.problemDes') }}：
        </div>
        <div class="errorValue">
          <!-- {{ errorInfo.errorDescription }} -->

          {{ eventsRules[curLang][errorInfo.errorCode].description }}
        </div>
      </div>
      <div class="errorRow">
        <div class="errorLabel">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="errorIcon" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="#525A80"></circle><path fill-rule="evenodd" clip-rule="evenodd" d="M6 8C6 7.44772 6.44772 7 7 7H17C17.5523 7 18 7.44772 18 8V17C18 17.3949 17.7676 17.7528 17.4068 17.9135C17.0461 18.0742 16.6246 18.0075 16.331 17.7433L14.6163 16.2H7C6.44772 16.2 6 15.7523 6 15.2V8ZM9.80156 12.7008C10.4643 12.7008 11.0016 12.1635 11.0016 11.5008C11.0016 10.838 10.4643 10.3008 9.80156 10.3008C9.13882 10.3008 8.60156 10.838 8.60156 11.5008C8.60156 12.1635 9.13882 12.7008 9.80156 12.7008ZM14.3008 12.7008C14.9635 12.7008 15.5008 12.1635 15.5008 11.5008C15.5008 10.838 14.9635 10.3008 14.3008 10.3008C13.638 10.3008 13.1008 10.838 13.1008 11.5008C13.1008 12.1635 13.638 12.7008 14.3008 12.7008Z" fill="white"></path></svg>
          {{ $t('error.alarm.problemReason') }}：
        </div>
        <div class="errorValue">
          <!-- {{ errorInfo.errorReason }} -->

          {{ eventsRules[curLang][errorInfo.errorCode].reason }}
        </div>
      </div>
      <div class="errorRow">
        <div class="errorLabel">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="errorIcon" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="#525A80"></circle><path fill-rule="evenodd" clip-rule="evenodd" d="M17.4448 7.83497C18.0882 8.35675 18.1869 9.30137 17.6651 9.94482L12.1651 16.7273C11.8918 17.0643 11.486 17.2665 11.0525 17.2816C10.6189 17.2968 10.1999 17.1235 9.9038 16.8065L5.9038 12.5239C5.33833 11.9185 5.3707 10.9693 5.97612 10.4038C6.58154 9.83837 7.53073 9.87075 8.09621 10.4762L10.9201 13.4995L15.3349 8.05528C15.8567 7.41182 16.8013 7.31319 17.4448 7.83497Z" fill="white"></path></svg>
          {{ $t('error.alarm.solution') }}
        </div>
      </div>
      <div class="errorAction">
        <div v-if="errorInfo.errorSolution.length !== 0">
          <!-- <template v-for="(item, index) in errorInfo.errorSolution.split('\n')" :key="item.value">
            <div class="errorActionRow">
            <div class="errorActionTitle">
              <div style="color: rgb(217, 13, 31);border-color: rgb(217, 13, 31);">{{index + 1}}</div>
            </div>
            <div class="errorActionValue">{{item.replace(/^\d+\.\s*/, "")}}</div>
          </div>
          </template> -->

          <template v-for="(item, index) in eventsRules[curLang][errorInfo.errorCode].action.split('\n')" :key="item.value">
            <div class="errorActionRow">
            <div class="errorActionTitle">
              <div style="color: rgb(217, 13, 31);border-color: rgb(217, 13, 31);">{{index + 1}}</div>
            </div>
            <div class="errorActionValue">{{item.replace(/^\d+\.\s*/, "")}}</div>
          </div>
          </template>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { request } from "@/utils/request";
import { common } from "../../common/mixin";
import Table from "@/components/table/index";
import Filter from "@/components/table/filter";
// import Dialog from "@/components/dialog/index";
import dayjs from 'dayjs'
import { computed } from "vue";
import { useStore } from "vuex"
import { zh, en, ja } from '@/locales/eventsRules'
import { color } from "echarts";
// import { useI18n } from 'vue-i18n'
// const { t } = useI18n()
export default {
  components: {
    Table,
    Filter
  },
  mixins: [common],
  data() {
    const store = useStore()
    return {
      params: [{
        key: 'robotId',
        value: '',
        label: this.$t('activity.packetjoin.robotCode')
      },{
        key: 'cabinetId',
        value: '',
        label: this.$t('collect.healthscorelist.ctrlCabCode')
      },
      {
        key: 'errorCode',
        value: '',
        label: this.$t('error.alarm.alarmCode')
      },
      {
        key: 'errorDescription',
        value: '',
        label: this.$t('error.alarm.alarmDetails')
      },
      {
        type: "Date",
        key: "dateRange",
        value: [dayjs().subtract(7, 'day').format('YYYY-MM-DD') +' 00:00:00', dayjs().format('YYYY-MM-DD') +' 23:59:59'],
        label: this.$t('error.alarm.occurrenceTime'),
        options: {
          "type": "datetimerange",
          "format": "YYYY-MM-DD HH:mm:ss",
          "value-format": "YYYY-MM-DD HH:mm:ss",
          "range-separator": this.$t('activity.detail.to'),
          "start-placeholder": this.$t('activity.list.startDate'),
          "end-placeholder": this.$t('activity.list.endDate'),
          "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
        }
      }],
      query: {},
      page: 1,
      size: 10,
      total: 0,
      tableDataList: [],
      dialogErrorCode: false,
      errorInfo: {},
      eventsRules: {
        "zh-CN": zh,
        "en-US": en,
        "ja-JP": ja,
      },
      curLang: computed(() => store.state.lang),
    };
  },
  created() {
  },
  mounted() {
    this.$refs.filterRef?.searchData()
  },
  methods: {
    getData() {
      request("getAlarm", {
        ...this.query,
        page: this.page,
        size: this.size,
      })
        .then((data) => {
          this.tableDataList = data.records;
          this.total = data.total;

          // this.tableDataList = data || [];
          // this.total = data.length;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getDataMap() {
      try {
        request("getArea", {
          parentId: 1,
        }).then((data) => {
          this.provinceList = data;
        });
        request("getRobotStatusMap").then((data) => {
          this.robotStatusList = data;
        });
        request("getIndustryList").then((data) => {
          this.industryList = data;
        });
      } catch (error) {
        console.log(error);
      }
    },
    searchData(data) {
      this.query = data
      this.getData()
    },
    updatePage(page, size) {
      this.page = page || 1
      this.size = size || 10
      this.getData()
    },
    handleClick() {
      this.getData();
    },
    errorInfoFun(item){
      this.errorInfo = item
      this.dialogErrorCode = true
    }
  },
};
</script>

<style lang="scss" scoped>
.errBoxMain {
  position: relative;
}

.errorRow {
  display: flex;
  margin-bottom: 24px;
}

.errorLabel {
  height: 25px;
  line-height: 25px;
  // min-width: 145px;
  color: #535a71;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: auto;
  .errorIcon {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
}

.errorValue {
  flex-grow: 1;
  line-height: 25px;
  white-space: pre-wrap;
  p {
    margin: 0;
    white-space: pre-wrap;
  }
}

.errorAction {
  border: 1.4px solid #d7d9e2;
  border-radius: 8px;
  height: 200px;
  margin-top: -10px;
  padding: 24px;
  overflow-y: auto;
}

.errorActionRow {
  display: flex;
  align-items: center;
  padding-bottom: 22px;
  overflow: hidden;
  position: relative;
  .border {
    position: absolute;
    border-left: 2px dashed #d7d9e2;
    height: 100%;
    left: 15px;
    top: calc(50% + 8px);
  }
  .border2 {
    position: absolute;
    border-left: 2px dashed #d7d9e2;
    height: 100%;
    left: 15px;
    bottom: calc(50% + 30px);
  }
}

.errorAction > :nth-child(1) > .border2 {
  display: none;
}

.errorActionTitle {
  width: 32px;
  height: 25px;
  min-width: 32px;
  div {
    width: 15px;
    height: 15px;
    border: 2.4px solid #d7d9e2;
    color: #535a71;
    border-radius: 50%;
    text-align: center;
    line-height: 15px;
    font-size: 14px;
    font-weight: 600;
  }
}


.errorActionValue {
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
}

.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;  
  display: flex;
  flex-direction: column;
}
:deep(.dialog__header) {
  height: 64px;
  background: #f1f2f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 32px;
}
</style>
